import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SignaturePadComponent} from '@shared/controls/signature-pad/signature-pad/signature-pad.component';
import {TypedSignaturePadComponent} from './typed-signature-pad/typed-signature-pad.component';
import {FormsModule} from '@angular/forms';
import {SignatureFontSelectorComponent} from './typed-signature-pad/signature-font-selector.component';
import {DropdownModule} from '@paperlessio/sdk/components/dropdown';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faChevronDown} from '@fortawesome/pro-regular-svg-icons';
import {AutoFocusModule} from '@shared/directives/auto-focus/auto-focus.module';

@NgModule({
  declarations: [SignaturePadComponent, TypedSignaturePadComponent, SignatureFontSelectorComponent],
  imports: [CommonModule, FormsModule, DropdownModule, FontAwesomeModule, AutoFocusModule],
  exports: [SignaturePadComponent, TypedSignaturePadComponent, SignatureFontSelectorComponent]
})
export class SignaturePadModule {
  constructor(lib: FaIconLibrary) {
    lib.addIcons(faChevronDown);
  }
}
